import { Component, type ErrorInfo, type ReactNode } from 'react';

/**
 * s766: ограда окна звонка. Окно живёт рядом с телефоном, над маршрутами, — сбой при его отрисовке
 * без ограды снял бы с экрана всё дерево вместе с телефоном, то есть оборвал бы разговор. С оградой
 * в худшем случае пропадает само окно; звонок, шапка и страница остаются как были.
 */
export class OknoZvonkaOgrada extends Component<{ children: ReactNode }, { slomano: boolean }> {
  state = { slomano: false };

  static getDerivedStateFromError(): { slomano: boolean } {
    return { slomano: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[телефон] окно звонка не отрисовалось — разговор не затронут', error, info.componentStack);
  }

  render() {
    return this.state.slomano ? null : this.props.children;
  }
}
